import {TransitionStep} from "html-living-framework";

export const STATE_LANDING_PAGE: string = "State_Landing";
export const STATE_CITY_SELECT: string = "State_CitySelect";
export const STATE_LEVEL_SELECT: string = "State_LevelSelect";

export const LOAD_INTERSTITIAL: string = "Load_Interstitial";
export const PAUSE: string = "Pause";

export const SPRITESHEET_UI: string[] = ["ui-1"];

export const FONT_GEL_LIGHT_22: string = "gelPenLight22";
export const FONT_GEL_MED_22: string = "gelPenMedium22";
export const FONT_GEL_MED_35: string = "gelPenMedium35";
export const FONT_GEL_MED_63: string = "gelPenMedium63";
export const FONT_LUNA: string = "lunaFont";

export const TWEEN_ONCOMPLETE: string = "onComplete";
export const TWEEN_ONREPEAT: string = "onRepeat";
export const TWEEN_ONUPDATE: string = "onUpdate";

export const VO_SPACING = 0.75;

export const DEBUG_MINIMAL_AUDIO: boolean = false;
export const DEBUG_SKIP_LOAD: boolean = false;
// export const DEBUG_DEFAULT_STATE: string | undefined = undefined;
export const DEBUG_DEFAULT_STATE: string | undefined = undefined;

export const GAME_MAX_WIDTH = 1664;
export const GAME_MAX_HEIGHT = 768;

export const DEFAULT_TRANSITION = [
    TransitionStep.AnimCurrentOut,
    TransitionStep.ShowLoadScreen,
    TransitionStep.RemoveCurrent,
    TransitionStep.UnloadAssets,
    TransitionStep.LoadAssets,
    TransitionStep.AttachNewBehind,
    TransitionStep.AnimNewIn,
    TransitionStep.HideLoadScreen,
    TransitionStep.UnloadUnusedAssets,
];
